module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch07"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_vm._v("Havana, Cuba")]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("T")])])]), _vm._v("he next time he saw Evangelina, she seemed thinner. Her face pinched, small lines of worry in her forehead, dark circles under her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You look as though you haven’t been sleeping.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She laughed at him. “I dream that I will sleep by the sea,” she said. “And then my dreams are interrupted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I have news for you,” he said. “Wait. I cannot tell you now. They are watching us. You speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you want me to tell you about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All of it.” He opened his pen so it would look like he was taking notes. He would take notes. He would continue to file stories.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Where do you want me to start?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“After they arrested your father…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She took a breath. “After they arrested my father,” she said, “we didn’t know what we were to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He was riding back from the cane fields. It was early morning, the morning we were to leave…” She hesitated. It was harder to tell this than she had thought it was going to be. She had told it once before, to Mr. Bryson, but then there had been an urgency to the telling and she had let him write it as he wanted. The result of that had been—a death sentence to Ceuta.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Decker sensed that she was having difficulty. “Is this hard for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t answer him at first, so he went on. “We could talk of other things,” he said. “I took a walk this morning on the beach. The water was pale blue, almost turquoise, and so clear, you could see through it to the ocean floor. Is it like that everywhere in Cuba?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. In Batabanó, where we spent the night on the wharf, before we were transported to the Isle of Pines, the ocean turns from black to white. It is said that it frightened Columbus’ sailors—they thought it was a portent of evil—but really, it is just the churl fish caught in the waves, making the water appear black, and, when they free themselves, the wake of their foam turns the ocean white—even the fish frightened the Spanish.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It would be harder for me not to tell this. But you must—promise me that you will listen.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“It was the morning that we were to leave to join the others in the mountains…and my father had gone to the fields to make it appear as though there was nothing unusual…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The Spanish soldiers found him there. They hit him in the back with the butt of their rifles, tied his hands behind him, put a rope on him as if he were cattle and made him walk along behind them, laughing when he fell down in the dirt. I understand he begged them to let him come to us and tell us he was leaving but they had no humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They found on him—papers that gave the whole plan of our uprising, for this he will not forgive himself, which led them to the others. We have tried to tell him that this isn’t true. No es verdad, Papa. No es verdad. They already "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v(" about the others from the same man who told them about him. But he holds himself responsible. From him, I have learned that you never write anything down. From him, I have learned that you must be very careful what you say.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Do you always write the truth, Mr. Duval? How do we know that what you print is the truth?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He needed her to trust him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Come closer.” The guards had walked away from them but only for a minute. He must speak quickly. He was aware of the way she smelled as she leaned her head in and his lips all but touched her hair when he spoke. “Costanza has a baby. A little girl. Alicia.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She said it after him, “Alicia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“They say that she looks very much the way that you did when you were little. She’s in a fishing village with your sisters and a woman who is pretending to be their mother. Will you—will you tell me where your father is?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I have not seen my father since the Isle of Pines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That is not what I asked you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She sat up straight and looked at him directly. “You will be very careful what you write about me, Mr. Duval.” It was almost a question. And then she smiled at him. He realized it was the first time he had seen her smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And then the guards were on her again and their interview ended abruptly. He watched as her face became porcelain, her figure docile, as she allowed them to lead her away. She knew better than to turn back and look at him. He waited until she disappeared inside the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Casa de Recojidas")]), _vm._v(" before taking his leave and wondered how much he would be able to tell her.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69dff42e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/whiterose_ch07.vue
// module id = 93
// module chunks = 0